import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';
import { APP_VERSION } from '../version';

const FOOTER_NEWS_COUNT = 2;

function Footer() {
  const [settings, setSettings] = useState({});
  const [newsItems, setNewsItems] = useState([]);

  useEffect(() => {
    api.get('/api/settings/public')
      .then(res => setSettings(res.data))
      .catch(err => console.error('Failed to fetch settings:', err));
    api.get('/api/news')
      .then(res => setNewsItems((res.data || []).slice(0, FOOTER_NEWS_COUNT)))
      .catch(() => setNewsItems([]));
  }, []);

  const hoursLines = settings.footer_hours_text
    ? settings.footer_hours_text.split('\n').filter(Boolean)
    : ['Segunda a sexta: 10h – 19h', 'Sábado: 10h – 17h', 'Domingo: Sob marcação'];

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section footer-section--news">
          <h4 className="footer-section-title">Novidades</h4>
          {newsItems.length > 0 ? (
            <>
              <div className="footer-news-cards">
                {newsItems.map((item, index) => (
                  <article key={item.id} className="footer-news-card">
                    {item.image_url && (
                      <Link to="/news" className="footer-news-card__image">
                        <img src={item.image_url} alt="" />
                      </Link>
                    )}
                    <div className="footer-news-card__body">
                      <h5 className="footer-news-card__title">{item.title}</h5>
                      {item.body && (
                        <p className="footer-news-card__text">
                          {item.body.length > 80 ? item.body.slice(0, 80).trim() + '…' : item.body}
                        </p>
                      )}
                    </div>
                  </article>
                ))}
              </div>
              <div className="footer-news-more">
                <Link to="/news" className="footer-news-link">Ver mais</Link>
              </div>
            </>
          ) : (
            <Link to="/news" className="footer-news-link">Ver novidades</Link>
          )}
        </div>
        <div className="footer-section">
          <h4 className="footer-section-title">{settings.footer_contact_heading || 'Contacto'}</h4>
          <ul className="footer-entries">
            {settings.contact_email && (
              <li className="footer-entry">
                <span className="footer-entry-label">Email</span>
                <a href={`mailto:${settings.contact_email}`} className="footer-entry-value">{settings.contact_email}</a>
              </li>
            )}
            {settings.contact_phone && (
              <li className="footer-entry">
                <span className="footer-entry-label">Telemóvel</span>
                <a href={`tel:${settings.contact_phone.replace(/\s/g, '')}`} className="footer-entry-value">{settings.contact_phone}</a>
              </li>
            )}
            {settings.contact_phone_landline && (
              <li className="footer-entry">
                <span className="footer-entry-label">Telefone</span>
                <a href={`tel:${settings.contact_phone_landline.replace(/\s/g, '')}`} className="footer-entry-value">{settings.contact_phone_landline}</a>
              </li>
            )}
            {settings.contact_address && (
              <li className="footer-entry">
                <span className="footer-entry-label">Morada</span>
                <span className="footer-entry-value">{settings.contact_address}</span>
              </li>
            )}
          </ul>
        </div>
        <div className="footer-section">
          <h4 className="footer-section-title">{settings.footer_hours_heading || 'Horário'}</h4>
          <ul className="footer-entries">
            {hoursLines.map((line, i) => (
              <li key={i} className="footer-entry">
                <span className="footer-entry-value">{line}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        {settings.site_tagline && (
          <p className="footer-bottom-motto">{settings.site_tagline}</p>
        )}
        <p className="footer-bottom-copyright">&copy; {new Date().getFullYear()} {settings.site_name || 'Wedding Attire'}. {settings.footer_bottom_text || 'Todos os direitos reservados.'}</p>
        <p className="footer-bottom-version" style={{ marginTop: '6px', fontSize: '0.75rem', opacity: 0.7 }}>v{APP_VERSION}</p>
      </div>
    </footer>
  );
}

export default Footer;
